// import axios from 'axios';

// VMS URL FOR OFFICE WIFI TESTING ONLY
// const axiosServices = axios.create({ baseURL: 'http://192.168.10.216:8000/' });

// VMS URL FOR CUSTOM TESTING ONLY
// const axiosServices = axios.create({ baseURL: 'http://172.20.10.2:8000/' });

// VMS URL FOR OUR SERVER
// const BASE_URL = 'https://vmsdev.sumadhuradev.com/api';
import axios from 'axios';

const BASE_URL = 'https://dev-vms.sipldev.com/api';

// Header's "DEVELOPMENT ENVIRONMENT" banner keys off this instead of NODE_ENV/build script,
// since every build (npm start, npm run build, build-stage) currently talks to this same
// hardcoded backend regardless of how it was built — this is the one thing that actually tells
// you which environment a running app is pointed at. Swap BASE_URL to a real production API
// (one whose host doesn't contain "dev") and the banner will stop showing on its own.
export const IS_DEV_BACKEND = BASE_URL.toLowerCase().includes('dev');

export const axiosV1 = axios.create({
  baseURL: `${BASE_URL}/v1/`
});

export const axiosV2 = axios.create({
  baseURL: `${BASE_URL}/v2/`
});

/* ===================== AUTH INTERCEPTOR (V2) ===================== */
axiosV2.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('serviceToken'); // 🔴 confirm key name

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// const axiosServices = axios.create({ baseURL: 'https://vmsdev.sumadhuradev.com/api/v1/' });
// const axiosServices = axios.create({ baseURL: 'http://10.1.2.89:8000/api/v1/' });

// URL FOR GETTING MOCK DATA
// const axiosServices = axios.create({ baseURL: 'https://mock-data-api-nextjs.vercel.app/' });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

// axiosServices.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.log(error);
//     // if (error.response.status === 401 && !window.location.href.includes('/login')) {
//     //   window.location.pathname = '/login';
//     // }
//     return Promise.reject((error.response && error.response.data) || 'Wrong Services');
//   }
// );

export default axiosV1;
